/**
 * Ruta pública `/activar/{token}` (US2, T033): puerta de entrada de la activación.
 *
 * La lógica vive en `features/activation/flow.tsx`; aquí solo se leen el token de la URL y el
 * parámetro `?paso=privacidad` (lo usa `/registrar` cuando la API responde `428`). El token nunca
 * se muestra ni se loguea: solo se pasa al flujo, que lo guarda en `sessionStorage`.
 */
import { createFileRoute } from '@tanstack/react-router';

import { ActivationFlow } from '../features/activation/flow';

/** `?paso=privacidad` es el único valor aceptado; cualquier otro se ignora. */
export interface ActivationSearch {
  paso?: 'privacidad';
}

export function ActivationRoute() {
  const { token } = Route.useParams();
  const { paso } = Route.useSearch();
  return <ActivationFlow token={token} startAtPrivacy={paso === 'privacidad'} />;
}

export const Route = createFileRoute('/activar/$token')({
  validateSearch: (search: Record<string, unknown>): ActivationSearch =>
    search.paso === 'privacidad' ? { paso: 'privacidad' } : {},
  component: ActivationRoute,
});
